import { useTranslation } from 'react-i18next';

export default function ComparisonSection() {
  const { t } = useTranslation();

  const rows = [
    { feature: 'Tempo ricerca', itaobuy: 'Molto veloce', manual: 'Lento' },
    { feature: 'Prodotti organizzati', itaobuy: '✓', manual: 'No' },
    { feature: 'Filtri categoria', itaobuy: '✓', manual: 'Limitati' },
    { feature: 'Guide italiane', itaobuy: '✓', manual: 'No' },
    { feature: 'Aggiornamenti', itaobuy: 'Frequenti', manual: 'Variabili' },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-12">
          {t('comparison.title', 'Itaobuy Spreadsheet vs ricerca tradizionale')}
        </h2>
        <div className="overflow-hidden rounded-xl border border-background-200/70">
          <table className="w-full">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-6 py-4 text-sm font-semibold text-foreground-800">Caratteristica</th>
                <th className="text-center px-6 py-4 text-sm font-semibold text-accent-700">
                  <span className="flex items-center justify-center gap-2">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-check-line text-sm"></i>
                    </span>
                    Itaobuy Spreadsheet
                  </span>
                </th>
                <th className="text-center px-6 py-4 text-sm font-semibold text-foreground-500">Ricerca manuale</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, idx) => (
                <tr key={idx} className={`${idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'} border-t border-background-200/70`}>
                  <td className="px-6 py-3.5 text-sm text-foreground-800 font-medium">{row.feature}</td>
                  <td className="px-6 py-3.5 text-sm text-center text-accent-600 font-semibold">{row.itaobuy}</td>
                  <td className="px-6 py-3.5 text-sm text-center text-foreground-500">{row.manual}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}